import { Phone, Mail, MapPin } from 'lucide-react';
import { useState, useEffect } from 'react';
import { getGeoLocation } from '@/lib/geolocation';

export default function TopBar() {
  const [location, setLocation] = useState('United States');

  useEffect(() => {
    const fetchLocation = async () => {
      const geoData = await getGeoLocation();
      if (geoData) {
        // Assuming the API returns location data, adjust based on actual response structure
        setLocation(geoData.country || geoData.city || geoData.region || 'United States');
      }
    };
    fetchLocation();
  }, []);

  return (
    <div className="top-0 left-0 right-0 z-[51] bg-[#064E3B] text-white py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-end gap-4 text-xs sm:text-sm">
          <div className="flex items-center gap-4 sm:gap-6">
            <a href="tel:+18005550199" className="flex items-center gap-2 hover:text-emerald-200 transition-colors">
              <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              <span>+1 (877) 685-1682</span>
            </a>
            <a href="mailto:info@trademarkpact.com" className="hidden sm:flex items-center gap-2 hover:text-emerald-200 transition-colors">
              <Mail className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              <span className="hidden sm:inline">info@trademarkpact.com</span>
            </a>
            <div className="hidden sm:flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              <span className="hidden sm:inline">18952 MacArthur Blvd Suite 100, Irvine, CA 92612</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
